import { render } from "./AddQuestion.vue?vue&type=template&id=75890198"
import script from "./AddQuestion.vue?vue&type=script&lang=js"
export * from "./AddQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__